import { useState } from "react";
import Markdown from "@/components/Markdown";
import Countdown from "@/components/Countdown";
import LegalModal from "@/components/LegalModal";
import SocialStrip from "@/components/SocialStrip";
import { useSiteSettings } from "@/context/SiteSettingsContext";
import { Rocket } from "lucide-react";

export default function PrelaunchScreen({ eyebrow, title, message, target, themeColor = "#00E5FF" }) {
  const { settings } = useSiteSettings();
  const [modal, setModal] = useState(null); // "impressum" | "datenschutz" | null
  const showEyebrow = !!(eyebrow && eyebrow.trim());
  const showTitle = !!(title && title.trim());
  return (
    <div className="min-h-screen flex flex-col bg-[#0B0F19] text-white" data-testid="prelaunch-screen">
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-3xl w-full">
          {(showEyebrow || showTitle) && (
            <>
              <div className="h-1 w-12" style={{ background: themeColor }} />
              {showEyebrow && (
                <div className="eyebrow flex items-center gap-2 mt-3" style={{ color: themeColor }}>
                  <Rocket className="w-3.5 h-3.5" /> {eyebrow}
                </div>
              )}
              {showTitle && (
                <h1
                  className="font-display font-black italic uppercase tracking-normal text-5xl sm:text-7xl leading-none mt-2"
                  style={{ textShadow: "0 4px 24px rgba(0,0,0,0.8)" }}
                  data-testid="prelaunch-title"
                >
                  {title}
                </h1>
              )}
            </>
          )}
          {message && (
            <div className="mt-6 text-neutral-300 max-w-2xl">
              <Markdown>{message}</Markdown>
            </div>
          )}
          {target && (
            <div className="mt-10">
              <Countdown target={target} themeColor={themeColor} centered />
            </div>
          )}
        </div>
      </div>
      <footer className="border-t border-white/5 py-6 bg-[#0B0F19]/80" data-testid="prelaunch-footer">
        <div className="max-w-3xl mx-auto px-6 flex items-center justify-between text-xs text-neutral-500 gap-4 flex-wrap">
          <span>© {new Date().getFullYear()} Sector Four</span>
          <SocialStrip settings={settings} themeColor={themeColor} />
          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={() => setModal("impressum")}
              className="hover:text-cyan-300 cursor-pointer"
              data-testid="prelaunch-impressum"
            >Impressum</button>
            <button
              type="button"
              onClick={() => setModal("datenschutz")}
              className="hover:text-cyan-300 cursor-pointer"
              data-testid="prelaunch-datenschutz"
            >Datenschutz</button>
          </div>
        </div>
      </footer>
      <LegalModal field={modal || "impressum"} open={!!modal} onClose={() => setModal(null)} />
    </div>
  );
}
